export const ResourceViewMode = {
    Active: 'active',
    Archived: 'archived'
};
